import {useState, useEffect} from 'react';
import {ReactComponent as Dots} from '@Assets/dots.svg';
import {ReactComponent as ProfilePicture} from '@Assets/blankProfile.svg';
import {ReactComponent as UsersIcon} from '@Assets/users.svg';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import ProfileView from '@CommonViews/ProfileView';
import TeamService from '@Helpers/URLHelpers/TeamService';
import ErrorHandler from '@Root/ErrorHandler';
import "./TeamBox.scss";

export default function TeamBox(props) {

    const [activeUsers, setActiveUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(0);
    const [showProfileView, setShowProfileView] = useState(false);
    const [showMemberListView, setShowMemberListView] = useState(false);
    const teamService = new TeamService();
    const errorHandler = new ErrorHandler();
    const className = 'teamBox';

    useEffect(() => {
        renderData();
    }, [])

    const renderData = async () => {
        try {
            let activeUsers = await teamService.getUserListByTeamId(props.team.id);
            activeUsers = JSON.parse(activeUsers.body);
            setActiveUsers(activeUsers);
        } catch (err) {
            errorHandler.handleError(err);
        }
    }

    const handleProfileClick = (id) => {
        setSelectedUserId(id);
        setShowProfileView(!showProfileView);
    }

    const toggleProfileView = () => {
        setShowProfileView(!showProfileView);
    }

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    }

    const toggleMemberListView = () => {
        setShowMemberListView(!showMemberListView);
    }

    const populateTeamProfiles = () => {
        let profilePics = [];
        for(let i = 0; i < activeUsers.length; i++) {
            if(i === 5) break;
            if( !activeUsers[i].photo ||
                activeUsers[i].photo === "null" ||
                URL.createObjectURL(dataURLtoFile.call(this, activeUsers[i].photo)).trim() === '') {
                profilePics = [...profilePics,
                    <ProfilePicture key={activeUsers[i].id} className={className + '__bottom__left__profilePicture'}
                        onClick={() => handleProfileClick(activeUsers[i].id)}/>]
            } else {
                profilePics = [...profilePics,
                    <img key={activeUsers[i].id} src={URL.createObjectURL(dataURLtoFile(activeUsers[i].photo))}
                        className={className + '__bottom__left__profilePicture'}
                        onClick={() => handleProfileClick(activeUsers[i].id)}
                        alt={''}
                    />
                ]
            }
        }
        if(activeUsers.length > 5) {
            profilePics = [...profilePics,
                <Dots className={className + '__bottom__left__profilePicture__more'} onClick={() => toggleMemberListView()}/>]
        }
        return profilePics;
    }

    return (
        <div className={className + ' width-wfa'}>
            <div className={className + '__top flex-row-center-space-between width-wfa'}>
                <div className={className + '__top__left flex-row-center-1rem-gap'}>
                    <div className={className + '__top__left__tag standard-tag'}> {props.team.tag} </div>
                    <div className={className + '__top__left__name standard-font'}> {props.team.teamName} </div>
                </div>
                <Tooltip title={"Users: " + activeUsers.length} slots={{ transition: Zoom }} arrow>
                    <div className={className + '__top__right flex-row-center-0p5rem-gap grey-text'}>
                        <UsersIcon className={className + '__top__right__icon'}/>
                        {activeUsers.length}
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}
